import { render } from "./ModalConfirmLayout.vue?vue&type=template&id=00cc7054&scoped=true"
import script from "./ModalConfirmLayout.vue?vue&type=script&lang=js"
export * from "./ModalConfirmLayout.vue?vue&type=script&lang=js"

import "./ModalConfirmLayout.vue?vue&type=style&index=0&id=00cc7054&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00cc7054"]])

export default __exports__